import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorDialogComponent } from "./error-dialog/error-dialog.component";
import { Error as APIError } from "src/app/api/models";

@Injectable({ providedIn: 'root' })
export class ErrorDialogService {
  private opened = false;

  constructor(private dialog: MatDialog) {}

  /**
   * `requestId` is the failed response's `X-Request-Id`, when it carried one —
   * the dialog turns "it broke" into a backend log lookup
   * (console-automatic-upgrade). Absent for legacy `/apiv2`, BFF-originated,
   * and non-HTTP errors.
   */
  openDialog(message: string, status?: number, requestId?: string): void {
    this.openErrorDialog({message: message}, status, requestId);
  }
  openErrorDialog(error: APIError, status?: number, requestId?: string): void {
    console.log("error dialog", error);

    if (!this.opened) {
      this.opened = true;
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        data: { error, status, requestId },
        maxHeight: "100%",
        width: "540px",
        maxWidth: "100%",
        disableClose: true,
        hasBackdrop: true,
      });

      dialogRef.afterClosed().subscribe(() => {
        this.opened = false;
      });
    }
  }
}
